import { PropsWithChildren } from 'react';
import { Button } from '@pairy/pds-react';

import * as Styled from './index.styles';

interface Props {
  onClick: () => void;
  disabled?: boolean;
}

const Footer = ({ children, disabled, onClick }: PropsWithChildren<Props>) => {
  return (
    <Styled.FlexWrapper
      justifyContent="center"
      backgroundColor="white"
      padding={{ y: 16 }}
    >
      <div>
        <Button
          variant="skyblue_500_fill"
          paddingY={16}
          radius={4}
          width="349px"
          textVariant="lg-medium"
          disabled={disabled}
          onClick={onClick}
        >
          {children}
        </Button>
      </div>
    </Styled.FlexWrapper>
  );
};

export default Footer;
